module.exports = __webpack_public_path__ + "img/logo.6a3486e.png";